import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ClinicalIndustry from "@/pages/ClinicalIndustry";

export const Route = createFileRoute("/en/industries/medical-devices/md-cro-cardiology")({
  head: () => buildRouteHead("/en/industries/medical-devices/md-cro-cardiology"),
  component: ClinicalIndustry,
});

